<div class="datatable-page-header">
  <h1>
    <span trans>Link Groups</span>
    <info-popover [wider]="true">
      <div class="title" trans>Group links together to:</div>
      <ul>
        <li trans>Simplify multiple link management.</li>
        <li trans>View statistics for a whole group instead of individual links.</li>
        <li trans>Share all links in the group with one link.</li>
        <li trans>And more.</li>
      </ul>
    </info-popover>
  </h1>

  <div class="header">
    <datatable-filters pluralName="groups" [filters]="filters"></datatable-filters>
    <div class="action-buttons">
      <permission-aware-button permission="link_groups.create">
        <button
          mat-raised-button
          color="accent"
          class="button-with-icon"
          (click)="showCrupdateGroupModal()"
          trans
        >
          <mat-icon svgIcon="add"></mat-icon>
          <span trans>Add New Group</span>
        </button>
      </permission-aware-button>
    </div>
  </div>
</div>

<div class="datatable responsive-table">
  <mat-progress-bar
    class="loading-bar"
    mode="indeterminate"
    color="accent"
    *ngIf="datatable.paginator && datatable.paginator.loading$ | async"
  ></mat-progress-bar>
  <table class="material-table">
    <thead>
      <tr>
        <th table-header-checkbox></th>
        <th table-sort-header trans>Name</th>
        <th *ngIf="showUserColumn()" table-sort-header="user_id" trans>Owner</th>
        <th table-sort-header="links_count" trans>Links</th>
        <th table-sort-header="active" trans>Active</th>
        <th table-sort-header="rotator" trans>Rotator</th>
        <th table-sort-header="updated_at" trans>Last Updated</th>
        <th></th>
      </tr>
      <tr *ngIf="datatable.selectedRows$.value.length as selectedCount">
        <th colspan="6">
          <div
            class="bulk-actions-title"
            [transValues]="{count: selectedCount, resource: 'group(s)'}"
            trans
          >
            :count :resource selected:
          </div>
          <div class="bulk-actions">
            <permission-aware-button permission="link_groups.delete">
              <button
                type="button"
                mat-raised-button
                color="warn"
                (click)="maybeDeleteSelectedGroups()"
                trans
              >
                Delete
              </button>
            </permission-aware-button>
          </div>
        </th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let group of groups$ | async">
        <td [table-body-checkbox]="group.id"></td>
        <td data-label="Name">
          <a class="link-group-name" [routerLink]="['/', group.hash]" target="_blank">{{
            group.name
          }}</a>
        </td>
        <td data-label="Owner" *ngIf="showUserColumn()">
          <user-column [user]="group.user"></user-column>
        </td>
        <td data-label="Link Count">{{ group.links_count }}</td>
        <td data-label="Active">
          <mat-icon svgIcon="check" *ngIf="group.active"></mat-icon>
          <span *ngIf="!group.active">-</span>
        </td>
        <td data-label="Rotator">
          <mat-icon svgIcon="check" *ngIf="group.rotator"></mat-icon>
          <span *ngIf="!group.rotator">-</span>
        </td>
        <td data-label="Last Updated">{{ group.updated_at | formattedDate }}</td>
        <td class="edit-column">
          <button
            type="button"
            mat-icon-button
            [routerLink]="[group.id, 'analytics']"
            [matTooltip]="'Analytics' | trans"
          >
            <mat-icon svgIcon="bar-chart"></mat-icon>
          </button>
          <permission-aware-button
            permission="link_groups.update"
            [userOwnsResource]="currentUser.get('id') === group.user_id"
          >
            <button
              type="button"
              [routerLink]="[group.id, 'links']"
              mat-icon-button
              [matTooltip]="'Manage Links' | trans"
            >
              <mat-icon svgIcon="list-alt"></mat-icon>
            </button>
          </permission-aware-button>
          <permission-aware-button
            permission="link_groups.update"
            [userOwnsResource]="currentUser.get('id') === group.user_id"
          >
            <button
              (click)="showCrupdateGroupModal(group)"
              mat-icon-button
              [matTooltip]="'Edit' | trans"
            >
              <mat-icon svgIcon="edit"></mat-icon>
            </button>
          </permission-aware-button>
          <copy-link-btn [model]="group"></copy-link-btn>
          <permission-aware-button permission="link_groups.delete" class="visible-on-mobile">
            <button
              type="button"
              mat-icon-button
              (click)="maybeDeleteSelectedGroups([group.id])"
              trans
            >
              <mat-icon svgIcon="delete"></mat-icon>
            </button>
          </permission-aware-button>
        </td>
      </tr>
    </tbody>
  </table>
  <no-results-message svgImage="marketing.svg" *ngIf="datatable.paginator.noResults$ | async">
    <span primary-text trans>No link groups have been created yet</span>
  </no-results-message>
  <datatable-footer></datatable-footer>
</div>
